<template>
    <div style="padding: 10px;">
        <!--
        {{node.trackID ? node.trackID : 'No track assigned'}} ||| {{node.getBounds()}}<br/>
        {{node.getMaxTextDistanceFromOrigin()}} vs {{node.getBounds().max.x - node.getBounds().min.x}}
        -->
        <b-container
            :id="`node-editor${node ? node.nodeid : '-no-node'}`"
            class="node-editor"
            :style="!timelineFormMode ? 'margin-bottom: 50px; padding: 5px;' : 'padding: 5px'"
            tabindex="0"
            :aria-label="`${isEvent ? 'Event' : 'Era'}: ${name}`"
        >
            <b-row align-h="between">
                <b-col cols="auto">
                    <tag-circle
                        v-if="editTag != null || node.important"
                        style="margin: -16px 0 0 0;"
                        :tag="editTag"
                        :important="node.important"
                        undeletable
                        unclickable
                    />
                </b-col>
                <b-col cols="auto">
                    <!--<h1>{{isEra ? 'Era' : 'Event'}}</h1>-->
                    <b-btn 
                        v-if="timelineFormMode" 
                        v-b-tooltip.hover 
                        :disabled="!checkTimelineWrite()" 
                        :title="(editing) ? 'finish editing' : `edit ${node.isEvent() ? 'event' : 'era'}`" 
                        :style="'border-radius: 8px; height: 33px; width: 40px; margin-top: -5px; margin-right: 10px; padding: 0 0 0 7px;'"
                        variant="cliovis-blue-light" 
                        size="sm" 
                        :aria-label="`edit ${node.isEvent() ? 'event' : 'era'}: ${name}`" 
                        @click="edit"
                    >
                        <i
                            :class="editing ? 'fas fa-check' : 'fas fa-edit'"
                            :style="editing ? 'font-size: 20px; padding: 2px 2px 0 0' : 'font-size: 18px'"
                        />
                    </b-btn> 
                    <b-btn 
                        v-if="timelineFormMode"
                        v-b-tooltip.hover 
                        :disabled="!checkTimelineWrite()" 
                        :title="`delete ${node.isEvent() ? 'event' : 'era'}`" 
                        style="border-radius: 8px; height: 33px; width: 40px; margin: -5px 10px 0 0; padding: 0 0 0 7px;"
                        variant="danger" 
                        size="sm" 
                        :aria-label="`delete ${node.isEvent() ? 'event' : 'era'}: ${name}`" 
                        @click="$refs.deleteModal.show()"
                    >
                        <i 
                            class="fas fa-trash" 
                            style="font-size: 20px; padding: 2px 2px 0 0"
                        />
                    </b-btn>
                    <b-btn
                        v-if="isEvent && !embedded && node.data && node.data.genealogyProvider"
                        v-b-tooltip.hover
                        :disabled="!checkTimelineWrite()" 
                        title="open genealogy importer" 
                        style="border-radius: 8px; height: 33px; width: 40px; margin: -5px 10px 0 0; padding: 0 0 0 7px;"
                        variant="cliovis-blue-light" 
                        size="sm" 
                        :aria-label="`open genealogy importer for event: ${name}`" 
                        @click="$emit('import-from-node')"
                    >
                        <i 
                            class="fas fa-people-arrows" 
                            style="font-size: 20px; padding: 2px 2px 0 0"
                        />
                    </b-btn>
                    <!-- FYI: remove the following `v-if="isEvent"` if you want to copy eras (text/code already adapts) -->
                    <b-btn
                        v-if="isEvent && !embedded"
                        v-b-tooltip.hover
                        :disabled="!checkTimelineWrite()" 
                        :title="`copy ${node.isEvent() ? 'event' : 'era'}`" 
                        style="border-radius: 8px; height: 33px; width: 40px; margin: -5px 10px 0 0; padding: 0 0 0 7px;"
                        variant="cliovis-blue-light" 
                        size="sm" 
                        :aria-label="`copy ${node.isEvent() ? 'event' : 'era'}: ${name}`" 
                        @click="openCopyModal()"
                    >
                        <i 
                            class="fas fa-copy" 
                            style="font-size: 20px; padding: 2px 2px 0 0"
                        />
                    </b-btn>
                    <b-btn 
                        v-if="isEvent && checkTimelineShare()" 
                        v-b-tooltip.hover 
                        :disabled="!checkTimelineShare()" 
                        title="export event" 
                        style="border-radius: 8px; height: 33px; width: 40px; margin-top: -5px;" 
                        variant="cliovis-blue-light" 
                        size="sm" 
                        :aria-label="`export event: : ${name}`" 
                        @click="node.exportToDocx()"
                    >
                        <img
                            aria-hidden="true"
                            style="width: 22px;"
                            src="../../../assets/icons/export-arrow.png"
                        >
                        <!--<span style="display: inline-block; color: #2c3e50; font-size: 13px; line-height: 1.4; margin: 5px 0 0 -9px">Export Event</span>-->
                    </b-btn>
                </b-col>
            </b-row>
            <b-row style="margin: 5px 0 5px 0">
                <b-col
                    class="d-flex justify-content-center align-items-center mb-3"
                    style="flex-direction: column; margin-top: 5px"
                    align-self="center"
                >
                    <!--<best-fit-text ref='nodeName' style="display: block; width: 100%; text-align: center;">{{name}}</best-fit-text>-->
                    <b-row class="d-flex justify-content-center align-items-center">
                        <h4
                            ref="eventName"
                            style="text-align: center; font-size: 28px"
                            tabindex="-1"
                        >
                            {{ name }}
                            <!-- {{ node.data }} -->
                        </h4>
                        <i 
                            v-if="node.timelines != undefined && node.timelines.length > 1"
                            v-b-tooltip.hover 
                            title="linked to another timeline"
                            :aria-label="`${name} is linked to another timeline`"
                            class="fas fa-link" 
                            style="font-size: 20px; padding: 2px 2px 0 0; color: black; margin-left: 15px;"
                        />
                    </b-row>
                </b-col>
            </b-row>
            <b-row v-if="isEvent">
                <b-col>
                    <div style="width: 90%; margin: auto;">
                        <div
                            v-if="isVideoValid"
                            v-html="node.video_html()"
                        />
                        <b-img
                            v-if="!isVideoValid || editing"
                            v-show="isImageLoaded && shouldDisplayImageInEditMode"
                            style="width: 100%; max-height: 50vh; margin: auto; object-fit: contain;"
                            :src="imageUrl"
                            :aria-label="node.imageCaption || name"
                        /> <!-- aria label falls back to name if there's no caption -->

                        <div 
                            v-show="isImageLoaded && shouldDisplayImageInEditMode && node.imageCaption != null"
                            style="font-size: 80%;"
                            aria-hidden="true"
                        >
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <span v-html="renderMarkdown(node.imageCaption)" />
                        </div>
                        
                        <!-- This isn't set up as best as it can be, but meh -->
                        <div
                            v-if="!isImageLoaded"
                            style="background-color: #363A3E; width: 100%; height: 300px;"
                        >
                            <div
                                style="width: 100%; height: 100%;"
                                class="d-flex justify-content-center mb-3"
                            >
                                <div style="margin: auto;">
                                    <b-spinner variant="light" />
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="validatingAudio">
                <div
                    style="width: 100%;margin-top: 10px;"
                    class="d-flex justify-content-center mb-3"
                >
                    <div style="margin: auto;">
                        <b-spinner />
                    </div>
                </div>
            </b-row>
            <b-row v-else-if="node.audio">
                <b-col style="margin-top: 10px;">
                    <audio
                        style="width: 90%; display: block; margin: auto;"
                        controls="controls"
                    >
                        <source :src="node.audio_url">
                        Your browser does not support the HTML5 Audio element.
                    </audio>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="margin-top: 10px;">
                    <p
                        v-if="dateStart !== dateEnd"
                        style="font-size: 26px; width: 100%; text-align: center;" 
                        :aria-label="
                            `${name} occurred from ${
                                node.dateStart.toLocaleDateString
                                    ? node.dateStart.toLocaleDateString(locale, ariaLocaleDateStringOptions())
                                    : dateStart
                            } to ${
                                node.dateEnd.toLocaleDateString
                                    ? node.dateEnd.toLocaleDateString(locale, ariaLocaleDateStringOptions())
                                    : dateEnd
                            }`
                        "
                        tabindex="0"
                    >
                        {{ dateStart }} - {{ dateEnd }}
                    </p>
                    <p
                        v-else
                        style="font-size: 26px; width: 100%; text-align: center;" 
                        :aria-label="
                            `${name} occurred on ${
                                node.dateStart.toLocaleDateString 
                                    ? node.dateStart.toLocaleDateString(locale, ariaLocaleDateStringOptions())
                                    : dateStart
                            }`
                        "
                        tabindex="0"
                    >
                        {{ dateStart }}
                    </p>
                </b-col>
            </b-row>
            
            <!-- Description/references -->
            <b-row>
                <b-col v-if="editing">
                    <b-form-group label="Name">
                        <b-form-input-limited
                            ref="nameForm"
                            v-model="editName"
                            :maxlength="50"
                            placeholder="Enter a name here"
                            label="name"
                            autofocus
                        />
                    </b-form-group>
                    <b-checkbox
                        v-model="editImportant"
                        style="margin-bottom: 1rem;"
                    >
                        Important
                    </b-checkbox>
                    <b-form-group label="Description">
                        <b-form-textarea-limited
                            v-model="editDescription"
                            :maxlength="5000"
                            label="description"
                        />
                    </b-form-group>
                    <node-date-options-selector
                        mutate-and-send-packet
                        :node="node"
                    />
                    <node-date-picker
                        ref="startDatePicker"
                        :start="hasDuration"
                        mutate-and-send-packet
                        :node="node"
                        @date-changed="startDateChanged"
                    />
                    <node-date-picker
                        ref="endDatePicker"
                        end
                        mutate-and-send-packet
                        :node="node"
                        @date-changed="endDateChanged"
                        @has-duration-changed="hasDurationChanged"
                    />
                    <b-form-group
                        v-if="isEvent"
                        label="Image URL"
                    >
                        <b-row>
                            <b-form-input-limited
                                v-model="editImageURL"
                                style="width: 84%; margin-left: 14px"
                                :maxlength="300"
                                placeholder="Paste a direct link to an image (.jpg, .jpeg, .png, .gif, .tiff) here"
                                label="image URL"
                                :disabled="validatingImage"
                                :state="editImageURL == '' ? null : editImageURLValid"
                            />
                            <b-btn
                                v-b-tooltip.hover="'image uploads'"
                                style="height: 38px; margin-left: 5px; padding: 0 0 0 5px; width: 10%; max-width: 48px"
                                variant="cliovis-blue-light"
                                aria-label="image uploads"
                                @click="$refs.uploadListModal.show(), displayImageUploads=true"
                            >
                                <i
                                    class="fas fa-folder-open"
                                    aria-hidden="true"
                                />
                            </b-btn>
                        </b-row>
                        <b-form-valid-feedback :state="validatingImage">
                            <span style="float: right; margin-top: -24px">Loading...</span>
                        </b-form-valid-feedback>
                        <b-alert
                            v-if="errorMsg != null || (editImageURL && editImageURL.length > 0 && !validatingImage && !editImageURLValid)" 
                            variant="danger" 
                            style="font-size: smaller; white-space: pre-line; padding: 4px 18px;"
                            show
                        >
                            <span>{{ errorMsg || 'Image URL is invalid.' }}</span>
                        </b-alert>
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="Image Caption"
                    >
                        <b-form-textarea-limited
                            v-model="editImageCaption"
                            :maxlength="200"
                            label="image caption"
                        />
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="Video URL"
                    >
                        <b-form-input-limited
                            v-model="node.video"
                            :maxlength="300"
                            placeholder="Paste a direct link to a video file (.mp4) or a YouTube link here"
                            label="Video URL"
                            :state="node.video == '' ? null : isVideoValid"
                            @input="onVideoUrlChanged"
                        />
                        <b-alert
                            v-if="videoErrorMsg != null || (node.video && node.video.length > 0 && !isVideoValid)" 
                            variant="danger" 
                            style="font-size: smaller; white-space: pre-line; padding: 4px 18px;"
                            show
                        >
                            <span>{{ videoErrorMsg || 'Video URL must be a direct link to a mp4 file or a YouTube link.' }}</span>
                        </b-alert>
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="Audio Clip URL"
                    >
                        <b-row>
                            <b-form-input-limited
                                v-model="editAudioURL"
                                style="width: 84%; margin-left: 14px"
                                :maxlength="300"
                                placeholder="Paste a direct link to an audio file (.mp3, .m4a, .wav, .ogg) here"
                                label="audio URL"
                                :disabled="validatingAudio"
                                :state="editAudioURL == '' ? null : editAudioURLValid"
                            />
                            <b-btn
                                v-b-tooltip.hover="'audio uploads'"
                                style="height: 38px; margin-left: 5px; padding: 0 0 0 5px; width: 10%; max-width: 48px"
                                variant="cliovis-blue-light"
                                aria-label="audio uploads"
                                @click="$refs.uploadListModal.show(), displayImageUploads=false"
                            >
                                <i
                                    class="fas fa-folder-open"
                                    aria-hidden="true"
                                />
                            </b-btn>
                        </b-row>
                        <b-form-valid-feedback :state="validatingAudio">
                            <span style="float: right; margin-top: -24px">Loading...</span>
                        </b-form-valid-feedback>
                        <b-alert
                            v-if="editAudioURL && editAudioURL.length > 0 && !validatingAudio && !editAudioURLValid" 
                            variant="danger" 
                            style="font-size: smaller; white-space: pre-line; padding: 4px 18px;"
                            show
                        >
                            <span>Audio Clip URL is invalid.</span>
                        </b-alert>
                    </b-form-group>
                    <b-form-group label="References">
                        <b-form-textarea-limited
                            v-model="editReferences"
                            :maxlength="1000"
                            label="references"
                        />
                        <reference-generator @generated="(ref) => editReferences = (editReferences + '\n' + ref).trim()" />
                    </b-form-group>
                    <color-slider 
                        v-if="!isEvent"
                        :node="node"
                    />
                    <b-form-group
                        v-if="isEvent"
                        label="Category"
                    >
                        <b-form-select
                            v-model="editTag"
                            aria-label="categories dropdown"
                        >
                            <option :value="null">
                                None
                            </option>
                            <option
                                v-for="(tag, key) in tagOptions"
                                :key="key"
                                :value="tag"
                            >
                                {{ tag.name }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                    <b-btn 
                        v-if="isEvent" 
                        block 
                        :style="`${timelineFormMode ? 'width: 88%; margin: auto;' : ''} margin-top: 10px; margin-bottom: 10px;`" 
                        @click="openConnectionManager"
                    >
                        <i
                            class="fas fa-share-alt"
                            style="font-size: 20px"
                        /> Open Connection Manager
                    </b-btn>
                </b-col>
                <b-col v-else>
                    <div
                        tabindex="0"
                        style="margin: 10px; background-color: #EADDC5; padding: 20px; max-height: 50vh; overflow-y: auto;"
                    >
                        <p>
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <span v-html="renderMarkdown(node.description)" />
                        </p>
                        <br>
                        <div style="font-size: 26px; font-weight: 500">
                            REFERENCES
                        </div>
                        <p>
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <span v-html="renderMarkdown(node.references)" />
                        </p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div
            v-if="!timelineFormMode"
            class="bottom-btns"
        >
            <b-row
                no-gutters
            >
                <b-col
                    v-if="!editing"
                    md="auto"
                    style="width: 11%; margin-right: 5px; min-width: 40px"
                >
                    <b-btn
                        v-b-tooltip="isEvent ? 'previous event' : 'previous era'"
                        style="width: 100%; padding: 5px 8px;"
                        variant="cliovis-grey-dark"
                        :aria-label="isEvent ? 'previous event' : 'previous era'"
                        @click.stop="previous"
                    >
                        <img
                            src="@/assets/icons/arrowLeft.png"
                            aria-hidden="true"
                            style="object-fit: contain; width: 100%; height: 100%;"
                        >
                    </b-btn>
                </b-col>
                <b-col
                    v-if="editing || !timelineFormMode"
                    md="auto"
                    :style="`${editing ? 'width: 46%; margin-right: 10px' : 'width: 36%; margin-right: 5px'}; ${embedded ? 'width: 73%' : ''}`"
                >
                    <b-btn
                        v-if="editing"
                        variant="danger"
                        block
                        @click="$refs.deleteModal.show()"
                    >
                        <i class="fas fa-trash" /> Delete
                    </b-btn>
                    <b-btn
                        v-else
                        block
                        @click="close"
                    >
                        Close <span style="color: white; font-size: 64%;">(C)</span>
                    </b-btn>
                </b-col>
                <b-col
                    v-if="!embedded"
                    md="auto"
                    :style="editing ? 'width: 47%;' : 'width: 36%; margin-right: 5px'"
                >
                    <b-btn
                        v-if="editing"
                        variant="cliovis-blue-light"
                        block
                        @click="editing = false"
                    >
                        Finish Editing
                    </b-btn>
                    <b-btn
                        v-else
                        variant="cliovis-blue-light"
                        block
                        :disabled="!checkTimelineWrite()"
                        @click="edit"
                    >
                        <i class="fas fa-edit" /> Edit
                    </b-btn>
                </b-col>
                <b-col
                    v-if="!editing"
                    md="auto"
                    style="width: 11%; min-width: 40px;"
                >
                    <b-btn
                        v-b-tooltip="isEvent ? 'next event' : 'next era'"
                        style="width: 100%; padding: 5px 8px;"
                        variant="cliovis-grey-dark"
                        :aria-label="isEvent ? 'next event' : 'next era'"
                        @click.stop="next"
                    >
                        <img
                            src="@/assets/icons/arrowRight.png"
                            aria-hidden="true"
                            style="object-fit: contain; width: 100%; height: 100%;"
                        >
                    </b-btn>
                </b-col>
            </b-row>
        </div>
        <div
            v-else-if="editing && !embedded"
            style="margin: auto; width: 87%; display: flex; flex-direction: row; justify-content: space-between;"
        >
            <b-btn 
                variant="danger" 
                style="width: 49%;"
                @click="$refs.deleteModal.show()"
            >
                <i class="fas fa-trash" /> Delete
            </b-btn>
            <b-btn 
                variant="cliovis-blue-light" 
                style="width: 49%;"
                @click="editing = false"
            >
                Finish Editing
            </b-btn>
        </div>

        <b-modal
            ref="copyModal"
            :title="`Copy ${node.isEvent() ? 'Event' : 'Era'}`"
            centered
            :ok-title="`${duplicateWhenCopied ? 'Duplicate' : 'Link'} ${node.isEvent() ? 'Event' : 'Era'}`"
            ok-variant="cliovis-blue-light"
            @ok="copyNode"
        >
            <p>Duplicate or link this {{ node.isEvent() ? 'Event' : 'Era' }} in the selected timeline.</p>
            <p>If you link this {{ node.isEvent() ? 'Event' : 'Era' }}, editing this {{ node.isEvent() ? 'Event' : 'Era' }} in one Timeline will change it in all Timelines.</p>
            <p>And if you link this {{ node.isEvent() ? 'Event' : 'Era' }} to a Timeline where it is already present, nothing will change.</p>
            <p>Duplicating or linking this {{ node.isEvent() ? 'Event' : 'Era' }} will also duplicate or link the corresponding Category, unless you're copying it to the same Timeline.</p>
            <b-form-group label="Duplicate or Link">
                <b-form-select
                    v-model="duplicateWhenCopied"
                    aria-label="duplicate or link dropdown"
                >
                    <option :value="true">
                        Duplicate
                    </option>
                    <option :value="false">
                        Link
                    </option>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Timeline">
                <b-form-select
                    v-model="copyDestinationTimeline"
                    aria-label="timeline dropdown"
                >
                    <option
                        v-for="(wtl, key) in writableTimelines"
                        :key="key"
                        :value="wtl"
                    >
                        {{ wtl.name }}
                    </option>
                </b-form-select>
            </b-form-group>
        </b-modal>

        <b-modal
            ref="deleteModal"
            :title="`Delete ${node.isEvent() ? 'Event' : 'Era'}`"
            centered
            ok-title="Delete"
            ok-variant="danger"
            @ok="deleteNode"
        >
            <p>Are you sure you want to delete this {{ node.isEvent() ? 'event' : 'era' }} (<strong>{{ node.name }}</strong>)? This action is irreversible.</p>
            <b-checkbox
                v-if="node.isEvent()"
                v-model="deleteIncludeCauses"
            >
                Include All {{ (node.data && node.data.genealogyProvider) ? 'Ancestors' : 'Connected Past Events' }}
            </b-checkbox>
            <b-checkbox
                v-if="node.isEvent()"
                v-model="deleteIncludeEffects"
            >
                Include All {{ (node.data && node.data.genealogyProvider) ? 'Descendants' : 'Connected Future Events' }}
            </b-checkbox>
        </b-modal>

        <b-modal
            ref="invalidImageModal"
            title="Invalid Image URL"
            centered
            ok-only
            ok-variant="cliovis-blue-light"
        >
            <p>{{ errorMsg }}</p>
        </b-modal>

        <b-modal 
            ref="connectionManagerModal" 
            :title="`Connection Manager for ${node.name}`" 
            centered 
            ok-only 
            ok-title="Close" 
            ok-variant="secondary"
            size="xl"
        >
            <connection-manager :node="node" />
        </b-modal>

        <b-modal
            ref="uploadListModal"
            centered
            title="Uploads"
            cancel-variant="cliovis-blue-light"
            cancel-title="Upload File"
            ok-variant="secondary"
            ok-title="Close"
            size="lg"
            @cancel="$refs.uploadModal.show()"
        >
            <template #modal-cancel>
                <i class="fas fa-file-upload" /> Upload File
            </template>
            <upload-list
                v-if="displayImageUploads"
                add-link
                just-images
                @close="addLinkAndHideModal"
            />
            <upload-list
                v-else
                add-link
                just-audio
                @close="addLinkAndHideModal"
            />
        </b-modal>

        <b-modal
            ref="uploadModal"
            centered
            title="Upload File"
            ok-only
            ok-variant="secondary"
            ok-title="Close"
            size="lg"
        >
            <upload />
        </b-modal>

        <!-- TODO: componentize the following so it can be reused in TimelineViewer, TimelineEditor, NodeEditor, etc. -->
        <b-modal 
            ref="eventLimitModal" 
            centered 
            size="lg" 
            title="Event Limit Reached for non-Premium User" 
            ok-only 
            ok-variant="secondary"
            ok-title="Close"
        >
            <p style="text-align: center">
                A non-premium user working in a non-upgraded project can only have <b>20 Events per timeline</b>.
            </p>
            <b-btn 
                v-if="checkTimelineWrite() && !user.isSubscribed && !user.trialing && $store.state.project.project.subscriptionTier < 1"
                v-b-tooltip.bottom="'Subscribing removes the limit'"
                block 
                style="margin: auto; margin-top: 10px; max-width: 90%" 
                variant="cliovis-blue-light" 
                size="sm" 
                @click="$refs.subscriptionModal.show()"
            >
                <i class="fas fa-plus" /> Increase Limit
            </b-btn>
        </b-modal>
        <b-modal
            ref="subscriptionModal"
            centered
            title="Subscribe"
            ok-only
            ok-variant="secondary"
            ok-title="Close"
            size="wide-3"
            no-close-on-backdrop
            no-close-on-esc
        >
            <subscription-panel />
            <div
                v-if="checkAdmin() && !$store.state.project.project.upgradedOverride"
                style="margin-top: 15px; text-align: center; align-items: center"
            >
                <span><i
                    class="fas fa-certificate"
                    style="font-size: 24px; margin-right: 6px; color: #247a59;"
                />Or, would you like to remove the limit for yourself and all non-premium users of this Project?</span>
                <b-btn
                    v-b-tooltip.ds550="'Upgrade this Project if you want to collaborate with non-premium users & pay for their access to this Project'"
                    block
                    pill
                    variant="outline-dark"
                    style="max-width: 300px; margin: auto; margin-top: 10px"
                    @click="$refs.upgradeProjectModal.show()"
                >
                    <i class="fas fa-file-invoice-dollar" /> Upgrade Project
                </b-btn>
            </div>
        </b-modal>
        <b-modal
            ref="upgradeProjectModal"
            size="wide-3"
            :centered="true"
            title="Upgrade Project - Manage Payment Plan"
            :hide-footer="true"
            no-close-on-backdrop
            no-close-on-esc
        >
            <subscription-panel
                project
                :pid="$store.state.project.project.id"
                :on-subscribe="() => { this.$router.push(`/app/reconnect/${$store.state.project.project.id}/${timeline.id}`); }"
            />
        </b-modal>
    </div>    
</template>

<script>
// TODO: convert to TS class
import Vue from 'vue';
import { mapGetters } from 'vuex';
import MarkdownIt from 'markdown-it';
// import { Audio, AudioListener } from 'three';
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
import BFormTextareaLimited from '@/components/input_limited/BFormTextareaLimited.vue';
// import BestFitText from "@/components/BestFitText.vue";
import ReferenceGenerator from "@/components/references/ReferenceGenerator";
import ColorSlider from '@/components/ColorSlider.vue';
import ConnectionManager from '@/components/ConnectionManager.vue';
import NodeDateOptionsSelector from '@/components/NodeDateOptionsSelector.vue';
import NodeDatePicker from '@/components/NodeDatePicker.vue';
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue';
import UploadList from '@/components/UploadList.vue';
import Upload from '@/components/Upload.vue';
import { IsEmbedded } from '@/constants/environment';
import Node from '@/models/Node';
import { PacketType } from '@/models/Packet';
import ProjectServer from '@/models/ProjectServer';
import StringPacking from '@/models/StringPacking';
import { SendPacket } from '@/networking/SendPacket';
import Mutations from '@/store/mutations';
import { handleImageSpecialCases } from '@/util/ImageUtil';
import CalculateTextSize from '@/util/TextSize';
import TagCircle from '@/views/timelineeditor/tagui/TagCircle.vue';
import KeyListener from '@/KeyListener';
import TimelineSyncRequests from '@/networking/TimelineSync';
import DateOptions from '@/models/DateOptions';

export default Vue.extend({
    components:
    {
        BFormTextareaLimited,
        BFormInputLimited,
        NodeDatePicker,
        NodeDateOptionsSelector,
        // BestFitText,
        ReferenceGenerator,
        TagCircle,
        ConnectionManager,
        ColorSlider,
        UploadList,
        Upload,
        SubscriptionPanel
    },
    props: 
    {
        node : Node
    },
    data()
    {
        return {
            originalVideoUrl: '',
            forceUpdateImgUrl: false,
            editing: false,
            editImgSrc: "",
            editAudioSrc: "",
            validatingAudio: false,
            validatingImage: false,
            forceUpdateDate: false,
            unsubscribeFromMutations: null,
            errorMsg: null,
            videoErrorMsg: null,
            displayImageUploads: false,
            duplicateWhenCopied: true,
            copyDestinationTimeline: null,
            hasDuration: true, // mirrored from end date picker
            deleteIncludeCauses: false,
            deleteIncludeEffects: false,
            md: new MarkdownIt(),
        };
    },
    computed: 
    {
        ...mapGetters([
            'checkTimelineWrite',
            'checkTimelineShare',
            'checkAdmin',
            'timelineFormMode',
            'timelines',
            'activeTimelineNodes',
            'nodes'
        ]),

        locale()
        {
            if (!navigator)
            {
                return 'en-US';
            }
            return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : (navigator.language || 'en-US');
        },

        shouldDisplayImageInEditMode()
        {
            return this.node.image != null && this.node.image != '';
        },

        isVideoValid()
        {
            return this.node.is_video_url_valid;
        },

        eventCount()
        {
            let numEvents = 0;
            for (const n of this.activeTimelineNodes)
            {
                if (!(n.isEra()))
                {
                    ++numEvents;
                }
            }
            return numEvents;
        },

        writableTimelines()
        {
            const tlarray = [];
            for (const tl of this.timelines.values())
            {
                if (this.checkTimelineWrite(tl.id))
                {
                    tlarray.push(tl);
                }
            }
            return tlarray;
        },

        embedded()
        {
            return IsEmbedded || this.$route.fullPath.includes('app/e/');
        },

        timeline()
        {
            return this.$store.state.project.activeTimeline;
        },

        tagOptions()
        {
            return this.timeline.tags;
        },

        editTag: 
        {
            get()
            {
                return this.node.tags.length == 0 ? null : this.node.tags[0];
            },
            set(value)
            {
                if (this.node.tags.length > 0)
                {
                    let tag = this.node.tags[0];
                    let data = {nodeid: this.node.nodeid, tagid: tag.tagid};
                    this.$store.commit(Mutations.removeNodeTag, data);
                    SendPacket(PacketType.NodeRemoveTag, data);
                }
                if (value)
                {
                    let tag = value;
                    let data = {nodeid: this.node.nodeid, tagid: tag.tagid};
                    this.$store.commit(Mutations.addNodeTag, data);
                    SendPacket(PacketType.NodeAddTag, data);
                }
            }
        },
        // Editing
        editName: 
        {
            get()
            {
                return this.node.name;
            },
            set(value) 
            {
                if (value.trim() != "")
                {
                    this.$store.commit(Mutations.updateNodeTitle, { nodeid: this.node.nodeid, value: value });
                    SendPacket(PacketType.NodeUpdateTitle, {nodeid: this.node.nodeid, value: this.node.name});
                }
            }
        },
        editImportant: 
        {
            get()
            {
                return this.node.important;
            },
            set(value) 
            {
                if (value != this.node.important)
                {
                    this.$store.commit(Mutations.updateNodeImportant, { nodeid: this.node.nodeid, value: value });
                    SendPacket(PacketType.NodeSetImportant, {nodeid: this.node.nodeid, value: value});
                }
            }
        },
        editDescription: 
        {
            get()
            {
                return this.node.description;
            },
            set(value) 
            {
                this.node.description = value;
                SendPacket(PacketType.NodeUpdateDescription, {nodeid: this.node.nodeid, value: StringPacking.Compress(this.node.description, this.node.references)});
            }
        },
        
        editReferences: 
        {
            get() 
            {
                return this.node.references;
            },
            set(value) 
            {
                this.node.references = value;
                SendPacket(PacketType.NodeUpdateDescription, {nodeid: this.node.nodeid, value: StringPacking.Compress(this.node.description, this.node.references)});
            }
        },

        editAudioURLValid()
        {
            return this.editAudioSrc == this.node.audio;
        },

        editAudioURL: 
        {
            get()
            {
                return this.editAudioSrc;
            },
            set(value) 
            {
                this.editAudioSrc = value;
                if (value.trim() == '')
                {
                    this.node.audio = '';
                    SendPacket(PacketType.NodeUpdateAudio, {nodeid: this.node.nodeid, value: this.node.audio});
                    return;
                }
                if (value.match(/[Hh][Tt][Tt][Pp]([Ss])?:\/\//))
                {
                    // TODO (ian): Make this actually use the HTML5 Audio API to validate that it is a valid audio file
                    /*
                    let audio = new Audio(value);
                    audio.src = value;
                    audio.onload = ()=>{
                        this.node.image = value;
                        SendPacket(PacketType.NodeUpdateAudio, {nodeid: this.node.nodeid, value: this.node.audio});
                    }
                    audio.onerror = ()=>{
                        
                    }*/
                    if (value.toLowerCase().match(/((\.wav)|(\.mp3)|(\.m4a)|(\.ogg))$/))
                    {
                        this.validatingAudio=true;
                        this.$http.get(`audio?url=${value}`).then(
                            (resp) =>
                            {
                                this.node.audio = value;
                                this.validatingAudio=false;
                                SendPacket(PacketType.NodeUpdateAudio, {nodeid: this.node.nodeid, value: this.node.audio});
                            },
                            () =>
                            {
                                this.validatingAudio=false;
                            }
                        );
                    }
                }
            }
        },

        editImageURLValid()
        {
            return this.editImgSrc == this.node.image;
        },
        
        editImageURL: 
        {
            get()
            {
                return this.editImgSrc;
            },
            set(value) 
            {
                console.log(`og: ${value}`);
                value = handleImageSpecialCases(value);
                console.log(`edited: ${value}`);
                this.editImgSrc = value;
                this.errorMsg = null;
                if (value.trim() == '')
                {
                    this.node.image = '';
                    SendPacket(PacketType.NodeUpdateImage, {nodeid: this.node.nodeid, value: this.node.image});
                    return;
                }
                if (value.match(/[Hh][Tt][Tt][Pp]([Ss])?:\/\//))
                {
                    if (value.toLowerCase().match(/((\.gif)|(\.jpg)|(\.jpeg)|(\.png)|(\.svg)|(\.tiff))(\?[A-Za-z=?&%0-9]+)?$/))
                    {
                        let image = new Image();
                        image.src = value;
                        this.validatingImage = true;
                        image.onload = () =>
                        {
                            this.node.image = value;
                            SendPacket(PacketType.NodeUpdateImage, {nodeid: this.node.nodeid, value: this.node.image});
                            this.validatingImage = false;
                        };
                        image.onerror = () =>
                        {
                            this.errorMsg = "Please make sure that the URL is correct and the image you'd like to use is the only thing on the URL's web page.";
                            this.validatingImage = false;
                        };
                    }
                    else
                    {
                        this.errorMsg = "The URL should include an image file extension: .gif, .jpg, .jpeg, .png, .svg, or .tiff";
                    }
                }
                else if(value.length > 7)
                {
                    this.errorMsg = "A valid image URL starts with either http:// or https://\n\n" +
                    "If you'd like to use an image that's on your computer then you need to upload it and then use the generated URL. You can do so by going to:\n\n" +
                    "Uploads & Snapshots -> Upload File";
                }
            }
        },

        editImageCaption: 
        {
            get()
            {
                return this.node.imageCaption;
            },
            set(value) 
            {
                this.$store.commit(Mutations.updateNodeImageCaption, { nodeid: this.node.nodeid, value: value });
                SendPacket(PacketType.NodeUpdateImageCaption, {nodeid: this.node.nodeid, value: this.node.imageCaption});
            }
        },

        // Getters
        yearStart() 
        {
            this.forceUpdateDate;
            let year = this.node.dateStart.getUTCFullYear();
            if (year < 0)
                return (-year).toString() + " BCE";
            return year.toString();
        },
        yearEnd()
        {
            this.forceUpdateDate;
            let year = this.node.dateEnd.getUTCFullYear().toString();
            if (year < 0)
                return (-year).toString() + " BCE";
            return year.toString();
        },
        dateStart() 
        {
            this.forceUpdateDate;
            let date = this.node.dateStart.getUTCBCString(this.node.dateOptions);
            return date;
        },
        dateEnd()
        {
            this.forceUpdateDate;
            let date = this.node.dateEnd.getUTCBCString(this.node.dateOptions);
            return date;
        },
        isNodeImageValid() 
        {
            return this.node.image.trim() != '';
        },
        loadedImage() 
        {
            console.log("LOADING");
            let img = new Image();
            img.src = this.rawImageUrl;
            if (!img.complete)
            {
                console.log("Image not cached");
                img.onload = () =>
                {
                    console.log('Image fully loaded');
                    this.forceUpdateImgUrl = !this.forceUpdateImgUrl;
                };
            }
            return img;
        },
        rawImageUrl() 
        {
            if (!this.node.image || this.node.image.trim() == '')
            {
                return this.timelineFormMode ? '' : '/images/placeholder_img.png';
            }
            return this.node.image;
        },
        isImageLoaded() 
        {
            if (!(this.rawImageUrl))
            {
                return true;
            }
            if (this.forceUpdateImgUrl && !this.forceUpdateImgUrl)
            {
                console.log('update!');
            }
            return this.loadedImage.complete;
        },
        imageUrl() 
        {
            this.forceUpdateImgUrl;
            let rawURL = this.rawImageUrl;
            return rawURL;
        },
        isEvent() 
        {
            return this.node.isEvent();
        },
        isEra() 
        {
            return this.node.isEra();
        },
        name() 
        {
            return this.node.name;
        }
    },
    watch: 
    {
        // TODO: This is a reactivity hack.  This should not be necessary.  I don't know why it is.
        // We really need to investigate our reactivity bugs in depth.
        editName()
        {
            if (this.node)
            {
                if (this.node.component)
                {
                    this.node.component.forceUpdateRender();
                }
            }
        },
        'node.image'(cur, old)
        {
            this.editImgSrc = cur;
        },
        editing(cur, old)
        {
            if (old && !cur)
            {
                this.onFinishedEditing();
            }
        }
    },
    mounted()
    {
        KeyListener.addKeyHandler(this);
        if (!(this.timelineFormMode))
        {
            this.$refs.eventName.focus();
        }
        else 
        {
            this.unsubscribeFromMutations = this.$store.subscribe((mutation, state) =>
            {
                if (mutation.type == Mutations.setSelected)
                {
                    this.checkSelected();
                }
            });

            this.checkSelected();
        }
        this.originalVideoUrl = this.node.video;
    },
    beforeDestroy()
    {
        KeyListener.removeKeyHandler(this);
        if (this.unsubscribeFromMutations != null)
        {
            this.unsubscribeFromMutations();
            this.unsubscribeFromMutations = null;
        }
    },
    methods: 
    {
        ariaLocaleDateStringOptions()
        {
            if (this.node == null)
            {
                return {
                    timeZone: 'UTC',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                };
            }
            return {
                timeZone: 'UTC',
                year: 'numeric',
                month: this.node.dateOptions.has(DateOptions.HideMonth) ? undefined : 'long',
                day: this.node.dateOptions.has(DateOptions.HideDay) ? undefined : 'numeric',
            };
        },
        renderMarkdown(text)
        {
            text = text || '';
            return this.md.render(text
                // pre-process
                .replace(/\<(?!\w*\:\/\/)([^\s]+\.[^\s]+)\>/g, '<https://$1>') // all links are absolute
            )
                // post-process
                .replace(/<a[ >]/g, '<a target="_blank" ') // all links target new tab/window
                .replace(/href="((?!\w+\:\/\/)[^"]+)"/g, 'href="https://$1"') // all links are absolute
                .replace(/<img[ >]/g, '<img style="max-width: 80%; max-height: 200vh; object-fit: contains;" '); // resize images
        },
        onVideoUrlChanged()
        {
            this.$set(this, 'videoErrorMsg', null);
            if (this.node.is_video_url_valid || this.node_video === '') 
            {
                SendPacket(PacketType.NodeUpdateVideo, {
                    nodeid: this.node.nodeid,
                    value: this.node.video
                });
            }

            if (!this.node.is_video_url_valid && this.video !== undefined) 
            {
                this.$set(this, 'videoErrorMsg', 'Invalid video URL.  Please provide a valid video URL.  The current value will not be saved.');
            }
        },
        calcSize(a, b, c)
        {
            return CalculateTextSize(a, b, c);
        },
        deleteNode()
        {
            const nodesToDelete = [];
            const deleteIdSet = new Set();
            let deleteCausesAfterEffects = false;
            if (this.deleteIncludeCauses && this.deleteIncludeEffects)
            {
                deleteCausesAfterEffects = true;
                this.deleteIncludeCauses = false;
                this.node.forAllChildren((c) =>
                {
                    deleteIdSet.add(c.nodeid);
                    nodesToDelete.push(c);
                });
            }
            else
            {
                deleteIdSet.add(this.node.nodeid);
                nodesToDelete.push(this.node);
            }
            while (nodesToDelete.length > 0)
            {
                const n = nodesToDelete.shift();

                n.forAllRelated((r) =>
                {
                    if (((n.dateStart > r.dateStart && this.deleteIncludeCauses)
                        || (n.dateStart < r.dateStart && this.deleteIncludeEffects)
                        || (n.dateStart == r.dateStart && (this.deleteIncludeCauses || this.deleteIncludeEffects)))
                        && !(deleteIdSet.has(r.nodeid)))
                    {
                        deleteIdSet.add(r.nodeid);
                        nodesToDelete.push(r);
                    }
                });

                if (n.timelines != null && n.timelines.length > 1)
                {
                    const data = { timelineid: this.timeline.id, nodeid: n.nodeid };
                    this.$store.commit(Mutations.removeTimelineNode, data);
                    SendPacket(PacketType.TimelineRemoveNode, data);
                }
                else
                {
                    SendPacket(PacketType.NodeDestroy, { nodeid: n.nodeid });
                }

                if (deleteCausesAfterEffects && nodesToDelete.length === 0)
                {
                    deleteCausesAfterEffects = false;
                    this.deleteIncludeCauses = true;
                    this.deleteIncludeEffects = false;
                    deleteIdSet.add(this.node.nodeid);
                    nodesToDelete.push(this.node);
                }
            }
            this.close();
            this.deleteIncludeCauses = false;
            this.deleteIncludeEffects = false;
        },
        startDateChanged()
        {
            this.forceUpdateDate = !(this.forceUpdateDate);
            this.$refs.endDatePicker.updateDate(); // check if the date is valid (won't cause unneeded mutations/packets)
            this.$emit('scroll-to-node'); // re-hits the scrollToNode code
        },
        endDateChanged()
        {
            this.forceUpdateDate = !(this.forceUpdateDate);
            this.$refs.startDatePicker.updateDate(); // check if the date is valid (won't cause unneeded mutations/packets)
            this.$emit('scroll-to-node'); // re-hits the scrollToNode code
        },
        hasDurationChanged(value)
        {
            this.hasDuration = value;
        },
        close()
        {
            this.$emit('close');
        },
        onFinishedEditing()
        {
            if (this.videoErrorMsg !== null) 
            {
                this.node.video = this.originalVideoUrl;
            }
        },
        edit() 
        {
            if(this.editing)
            {
                this.editing = false;
                const element = document.findElementById(`node-editor-${this.node.nodeid}`);
                if (element) element.focus();
                return;
            }

            this.editImgSrc = this.node.image;
            this.editAudioSrc = this.node.audio;
            this.editing = true;
        },
        checkSelected()
        {
            if (this.$store.state.project.selected != null && this.$store.state.project.selected.nodeid === this.node.nodeid)
            {
                if (this.editing)
                {
                    this.$nextTick(() =>
                    {
                        this.$refs.nameForm.focus();
                    });
                }
                else
                {
                    this.$nextTick(() =>
                    {
                        this.$refs.eventName.focus();
                    });
                }
            }
        },
        openConnectionManager()
        {
            this.$refs.connectionManagerModal.show();
        },
        closeConnectionManager()
        {
            this.$refs.connectionManagerModal.hide();
        }, 
        previous()
        {
            // get the previous nodeid from timeline.getEventOrdering(), close this, open that one
            this.close();
            let ordering = null;
            if(this.isEvent)
            {
                ordering = this.timeline.getEventOrdering();
            }
            else
            {
                ordering = this.timeline.getEraOrdering();
            }
            let index = ordering.indexOf(this.node.nodeid);
            index = ((index - 1) >= 0) ? (index - 1) : ordering.length - 1;
            let n = this.$store.getters.nodes.get(ordering[index]);
            if (n != null && n.component != null)
            {
                if(this.isEvent)
                {
                    n.component.onNodeClick(null, true);
                }
                else
                {
                    n.component.onEraClick();
                }
            }
        },
        next()
        {
            // get the next nodeid from timeline.getEventOrdering(), close this, open that one
            this.close();
            let ordering = null;
            if(this.isEvent)
            {
                ordering = this.timeline.getEventOrdering();
            }
            else
            {
                ordering = this.timeline.getEraOrdering();
            }
            let index = ordering.indexOf(this.node.nodeid);
            index = ((index + 1) < ordering.length) ? (index + 1) : 0;
            let n = this.$store.getters.nodes.get(ordering[index]);
            if (n != null && n.component != null)
            {
                if(this.isEvent)
                {
                    n.component.onNodeClick(null, true);
                }
                else
                {
                    n.component.onEraClick();
                }
            }
        },
        keyHandler(_event, isTextBoxFocused)
        {
            if (!isTextBoxFocused)
            {
                if (KeyListener.isPeriodDown())
                {
                    this.next();
                }
                else if (KeyListener.isCommaDown())
                {
                    this.previous();
                }
            }
        },
        addLinkAndHideModal(str, image)
        {
            this.$refs.uploadListModal.hide();
            if(image)
            {
                let image = new Image();
                image.src = str;
                this.editImgSrc = image.src;
                this.validatingImage = true;
                image.onload = () =>
                {
                    this.node.image = str;
                    SendPacket(PacketType.NodeUpdateImage, {nodeid: this.node.nodeid, value: this.node.image});
                    this.validatingImage = false;
                };
                image.onerror = () =>
                {
                    this.validatingImage = false;
                };
            }
            else
            {
                this.editAudioSrc = str;
                this.validatingAudio = true;
                this.$http.get(`audio?url=${str}`).then(
                    (resp) =>
                    {
                        this.node.audio = str;
                        this.validatingAudio = false;
                        SendPacket(PacketType.NodeUpdateAudio, {nodeid: this.node.nodeid, value: this.node.audio});
                    },
                    () =>
                    {
                        this.validatingAudio = false;
                    }
                );
            }
        },
        openCopyModal()
        {
            console.log(this);
            this.copyDestinationTimeline = this.timeline;
            this.$refs.copyModal.show();
        },
        countEvents(tl)
        {
            let numEvents = 0;
            for (const nodeid of tl.nodeIDs)
            {
                const n = this.nodes.get(nodeid);
                if (n.isEvent())
                {
                    ++numEvents;
                }
            }
            return numEvents;
        },
        async copyNode()
        {
            if (this.copyDestinationTimeline.id !== this.timeline.id)
            {
                console.log('syncing target timeline');
                console.log({TimelineSyncRequests, id: this.copyDestinationTimeline.id, copyDestinationTimeline: this.copyDestinationTimeline});
                await TimelineSyncRequests.SyncTimeline(this.copyDestinationTimeline.id);
                console.log('done syncing');
            }
            else
            {
                console.log('no sync required');
            }
            
            console.log('checking event count');
            // first check the free tier event limit
            if ((this.eventCount >= 20 || this.countEvents(this.copyDestinationTimeline) >= 20)
                && !(this.user.isSubscribed)
                && !(this.user.trialing) 
                && !(this.$store.state.project.project.upgradedOverride) 
                && (this.$store.state.project.project.subscriptionTier < 1))
            {
                this.$refs.eventLimitModal.show();
                return;
            }

            console.log('preparing to copy');
            if (this.duplicateWhenCopied)
            {
                console.log('duplicating');
                if (this.editTag != null 
                    && this.timeline.id !== this.copyDestinationTimeline.id
                    && !(this.copyDestinationTimeline.tags.some((t) => 
                    {
                        return t.tagid === this.editTag.tagid; 
                    })))
                {
                    let tid = -1;
                    for (const tag of this.copyDestinationTimeline.tags)
                    {
                        if (tag.name === this.editTag.name)
                        {
                            tid = tag.id;
                            break;
                        }
                    }
                    if (tid === -1)
                    {
                        console.log('path 1');
                        // TODO: awaitable packet would be better
                        let cb = ProjectServer.instance.registerCallback(PacketType.TagCreate, (data) =>
                        {
                            if (data.name === this.editTag.name)
                            {    
                                console.log('received, creating node');
                                const oldid = this.editTag.tagid;
                                this.editTag.tagid = data.tagid;
                                Node.create(this.node, this.copyDestinationTimeline.id);
                                this.editTag.tagid = oldid;
                                this.$parent.$bvToast.toast(`Duplicated ${this.node.isEvent() ? 'event' : 'era'} ${this.node.name} to timeline: ${this.copyDestinationTimeline.name}!`,
                                    {
                                        variant: 'primary',
                                        autoHideDelay: 5000
                                    });
                                ProjectServer.instance.removeCallback(PacketType.TagCreate, cb);
                            }
                        });
                        
                        SendPacket(PacketType.TagCreate, 
                            {
                                type: 'category',
                                name: this.editTag.name,
                                color: this.editTag.color,
                                timelineid: this.copyDestinationTimeline.id
                            });
                    }
                    else
                    {
                        console.log('path 2, creating...');
                        const oldid = this.editTag.tagid;
                        this.editTag.tagid = tid;
                        Node.create(this.node, this.copyDestinationTimeline.id);
                        this.editTag.tagid = oldid;
                        this.$parent.$bvToast.toast(`Duplicated ${this.node.isEvent() ? 'event' : 'era'} ${this.node.name} to timeline: ${this.copyDestinationTimeline.name}!`,
                            {
                                variant: 'primary',
                                autoHideDelay: 5000
                            });
                    }
                }
                else
                {
                    console.log('path 3, creating...');
                    Node.create(this.node, this.copyDestinationTimeline.id);
                    this.$parent.$bvToast.toast(`Duplicated ${this.node.isEvent() ? 'event' : 'era'} ${this.node.name} to timeline: ${this.copyDestinationTimeline.name}!`,
                        {
                            variant: 'primary',
                            autoHideDelay: 5000
                        });
                }
            }
            else // link
            {
                console.log('linking');
                // note that in this case, there's nothing to await and order doesn't matter
                if (this.timeline.id !== this.copyDestinationTimeline.id)
                {
                    console.log('checking tag');
                    if (this.editTag != null 
                        && !(this.copyDestinationTimeline.tags.some((t) => 
                        {
                            return t.tagid === this.editTag.tagid; 
                        })))
                    {
                        console.log('adding tag');
                        SendPacket(PacketType.TimelineAddTag,
                            { 
                                tagid: this.editTag.tagid,
                                timelineid: this.copyDestinationTimeline.id
                            });
                    }
                    if (!(this.copyDestinationTimeline.nodeIDs.some((n) => 
                    {
                        return n === this.node.nodeid; 
                    })))
                    {
                        console.log('add node');
                        const data =
                        { 
                            nodeid: this.node.nodeid,
                            timelineid: this.copyDestinationTimeline.id
                        };
                        SendPacket(PacketType.TimelineAddNode, data);
                    }
                }
                this.$parent.$bvToast.toast(`Linked ${this.node.isEvent() ? 'event' : 'era'} ${this.node.name} to timeline: ${this.copyDestinationTimeline.name}!`,
                    {
                        variant: 'primary',
                        autoHideDelay: 5000
                    });
            }
        }
    },
});
</script>

<style lang="scss">
// This one is for non-scoped classes
.node-video
{
    width: calc(26vw);
    height: calc(26vw * 9 / 16);
}

.node-editor
{
    th
    {
        padding: 0 10px;
    }

    td
    {
        padding: 2px 10px;
        border: 1px solid #555;
    }
}
</style>

<style lang="scss" scoped>
// This one is for scoped classes
.bottom-btns
{
    width: 30vw; 
    min-width: calc(min(375px, 100vw)); 
    max-width: calc(min(1024px, 100vw));
    position: fixed;
    bottom: 0; 
    left: 0;
    padding: 14px 5px 16px 12px; 
    margin: 0;
    background-color: rgb(251,249,247);
}
</style>